import { ToastPosition } from '@app/modules/toasts/models/interfaces/toast.interfaces';

export const TOAST_DEFAULT_TIMEOUT: number = 4000;

export const TOAST_POSITION_TO_CLASSES: Map<ToastPosition, string> = new Map<ToastPosition, string>(
    [
        ['top-start', 'top-0 start-0'],
        ['top-center', 'top-0 start-50 translate-middle-x'],
        ['top-end', 'top-0 end-0'],
        ['middle-start', 'top-50 start-0 translate-middle-y'],
        ['middle', 'top-50 start-50 translate-middle'],
        ['middle-end', 'top-50 end-0 translate-middle-y'],
        ['bottom-start', 'bottom-0 start-0'],
        ['bottom-center', 'bottom-0 start-50 translate-middle-x'],
        ['bottom-end', 'bottom-0 end-0']
    ]
);
